import {shareLink} from '../functions/share';

interface ShareImage {
    image: string;
}

export const getEmailBody = async (text: string, eventLink: string, image?: ShareImage) => {
    let body = text + ' ' + eventLink;
    
    if(image?.image) {
        const base64Image = (image.image);
        body += `\n\n${base64Image}`;
    }
    
    return body;
};

export const getImageFile = async (imageUrl: string) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const file = new File([blob], 'event_image.jpg', {type: 'image/jpeg'});
    return file;
};

export const handleMobileShare = async (title: string, text: string, eventLink: string, imageUrl?: string) => {
    try {
        // For mobile share, we can use native sharing with files
        if(navigator.share && imageUrl) {
            // Try to get the image as a file to share it
            const file = await getImageFile(imageUrl);
            
            await navigator.share({
                title: title,
                text: text,
                url: eventLink,
                files: [file]
            } as any);
        } else {
            // Fallback to regular sharing without image
            shareLink(title, text, eventLink);
        }
    } catch (error) {
        console.error('Error sharing:', error);
        // Fallback to standard sharing
        shareLink(title, text, eventLink);
    }
};

export const shareContent = async (platform: string, title: string, text: string, eventLink: string, imageUrl?: string) => {
    
    const body = await getEmailBody(text, eventLink, imageUrl ? {image: imageUrl} : undefined);
    
    // Desktop-specific sharing methods
    switch (platform) {
        case 'facebook':
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventLink)}`, 'facebook-share-dialog', 'width=626,height=436');
            break;
        case 'whatsapp':
            // For WhatsApp web version, include the image as a link in the text
            window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(text + ' ' + eventLink)}${imageUrl ? ' ' + encodeURIComponent(imageUrl) : ''}`);
            break;
        case 'email':
            window.open(`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}&ui=2&tf=1&pli=1`, 'sharer', 'toolbar=1,status=1,width=648,height=395');
            break;
        case 'twitter':
            window.open(`http://twitter.com/share?url=${encodeURIComponent(eventLink)}&text=${encodeURIComponent(text)}${imageUrl ? ' ' + encodeURIComponent(imageUrl) : ''}`, 'twitterwindow', 'height=450, width=550, top=0, left=0, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            break;
        default:
            shareLink(title, text, eventLink);
    }
};
